import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { CircadianEvent, RecipeSection } from '@ledium/types';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { Button, Grid } from '@mui/material';

interface SectionAddNewEventButtonProps {
    sectionData: RecipeSection;
    setSectionData: (data: RecipeSection) => void;
}

const emptyCircadianEvent = { hour: 0, minute: 0, lightRecipeId: null } as unknown as CircadianEvent;

const SectionAddNewEventButton = ({ sectionData, setSectionData }: SectionAddNewEventButtonProps) => {
    const {
        pageState: { formData }
    } = usePageStore();
    const buttonRef = React.useRef<HTMLDivElement>(null);
    const reshowButton = React.useRef(false);
    const [showButton, setShowButton] = React.useState(true);

    React.useEffect(() => {
        const visible = (!sectionData.circadianEvents.length || sectionData.circadianEvents.every((event) => event.lightRecipeId)) && !formData.readOnly;
        if (visible && !showButton) {
            reshowButton.current = true;
        }
        setShowButton(!!visible);
    }, [showButton, sectionData.circadianEvents, formData.readOnly]);

    React.useLayoutEffect(() => {
        if (!reshowButton.current) {
            return;
        }

        if (showButton) {
            buttonRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [showButton]);

    function onAddNewCircadianEvent() {
        setSectionData({ ...sectionData, circadianEvents: [...sectionData.circadianEvents, emptyCircadianEvent] });
    }

    return (
        <>
            {showButton ? (
                <Grid ref={buttonRef} item xs={12} style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <Button variant="contained" onClick={onAddNewCircadianEvent} startIcon={<AddBoxIcon />}>
                        {i18n('add_new_light_event_button')}
                    </Button>
                </Grid>
            ) : null}
        </>
    );
};

export default SectionAddNewEventButton;
